import React from "react";
import { Download, FileJson, FileSpreadsheet } from "lucide-react";
import { Button } from "./ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "./ui/dropdown-menu";
import { exportCSVUrl, exportJSONUrl } from "../lib/api";

export function ExportMenu() {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          data-testid="export-menu-btn"
          variant="outline"
          className="border-zinc-800 bg-zinc-900/60 hover:bg-zinc-800 text-zinc-100 rounded-md font-medium"
        >
          <Download className="w-4 h-4 mr-2" />
          Export
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        align="end"
        className="bg-zinc-900 border-zinc-800 text-zinc-100"
      >
        <DropdownMenuItem
          data-testid="export-csv-item"
          className="cursor-pointer focus:bg-zinc-800"
          onClick={() => window.open(exportCSVUrl(), "_blank")}
        >
          <FileSpreadsheet className="w-4 h-4 mr-2 text-emerald-400" />
          Export as CSV
        </DropdownMenuItem>
        <DropdownMenuItem
          data-testid="export-json-item"
          className="cursor-pointer focus:bg-zinc-800"
          onClick={() => window.open(exportJSONUrl(), "_blank")}
        >
          <FileJson className="w-4 h-4 mr-2 text-amber-400" />
          Export as JSON
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}

export default ExportMenu;
